import * as React from "react";
import {connect} from "react-redux";
import { IPatientDetail } from "@curefit/care-common";
import {PatientCompleteInfoActions} from "../../actions/PatientCompleteInfoActions";

interface RelatedPatientListProps {
    onPatientClick: (patientId: number, event: void) => void
}

interface RelatedPatientListStateToProps {
    profile: IPatientDetail,
}

interface RelatedPatientListDispatchProps {
    searchPatients: (curefitUserId: string) => Promise<any>
}

interface RelatedPatientsListState {
    patients: any[],
    isLoading: boolean,
    error: string
}

interface PatientRendererProps {
    patient: any
}

const PatientRenderer = (props: PatientRendererProps) => {
    const {patient} = props;
    const ageString = patient.age ? `, ${patient.age} years` : "";
    const genderString = patient.gender ? `, ${patient.gender}` : "";
    return (
        <span>{`${patient.name}${ageString}${genderString}`}</span>
    );
};

class RelatedPatientList extends React.Component<RelatedPatientListProps & RelatedPatientListDispatchProps & RelatedPatientListStateToProps, RelatedPatientsListState> {
    state: RelatedPatientsListState = {
        patients: null,
        isLoading: false,
        error: null
    };

    handleClick = (patientId: number) => (event: any) => {
        this.props.onPatientClick(patientId, event)
    };

    componentDidMount(): void {
        const {searchPatients, profile: { curefitUserId, id } } = this.props;
        this.setState({isLoading: true});
        searchPatients(curefitUserId).then(patients => {
            this.setState({patients: patients.filter((patient: any) => patient.id !== id), isLoading: false})
        }).catch(err => {
            this.setState({isLoading: false, error: "Oops!, some error occurred"})
        });
    }

    componentDidCatch (error: any, info: any) {
        console.log("ERROR", error)
        console.log("INFO", info)
    }

    render() {
        const {patients, isLoading, error} = this.state;
        return (
            <div className="related-patients-container">
                { isLoading ? "Loading..." : null }
                { error ? <div className="error">{error}</div> : null }
                { patients &&
                    <ul>
                        {patients.length ? patients.map(
                            patient => <li>
                                <a href="javascript:;" onClick={this.handleClick(patient.id)}>
                                    <PatientRenderer patient={patient} />
                                </a>
                            </li>
                        ) : "No patients found!" }
                    </ul>
                }
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch: any): RelatedPatientListDispatchProps => {
    return {
        searchPatients: function (curefitUserId: string) {
            return PatientCompleteInfoActions.searchPatients(curefitUserId, dispatch)
        }
    }
};

const mapStateToProps = (state: any): RelatedPatientListStateToProps => {
  return {
    profile: state.patientCompleteInfo.profile
  };
};

export default connect<
  RelatedPatientListStateToProps, RelatedPatientListDispatchProps,
  RelatedPatientListProps
>(
  mapStateToProps,
  mapDispatchToProps
)(RelatedPatientList);